module.exports = __webpack_public_path__ + "cc3f1c82550badea8bdeb16fa770adf4.jpg";